import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogComponent, DialogConfiguration, TranslationPipe } from '@prekog/common-ui';
import { ConfirmSubscribersDialogResult } from './confirmsubscribersdialogresult';

@Component({
    selector: 'app-confirmsubscribersdialog',
    templateUrl: './confirmsubscribersdialog.component.html',
    styleUrls: ['./confirmsubscribersdialog.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatDialogModule, TranslationPipe]
})
export class ConfirmsubscribersDialogComponent extends DialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public dialogconfiguration: DialogConfiguration) {
        super();
    }

    sendToAllSubscribers() {
        const confirmSubscribersDialogResult: ConfirmSubscribersDialogResult = {
            sendToNewRecipients: false
        }
        this.accept(confirmSubscribersDialogResult);
    }

    sendToNewSubscribers() {
        const confirmSubscribersDialogResult: ConfirmSubscribersDialogResult = {
            sendToNewRecipients: true
        }
        this.accept(confirmSubscribersDialogResult)
    }
}
